function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;


//////////////////
// WEBPACK FOOTER
// ./node_modules/yup/node_modules/@babel/runtime/helpers/builtin/interopRequireDefault.js
// module id = 33
// module chunks = 0